module.exports = __webpack_public_path__ + "img/Camera8.15009be6.png";